// frontend/src/hooks/useAdminSentry.ts
import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface SentryTopIssue {
  id: string;
  title: string;
  count_24h: number;
  last_seen_at: string; // ISO 8601 UTC
}

export interface SentrySparklineBucket {
  bucket_start: string; // ISO 8601 UTC
  count: number;
}

export interface SentrySummaryTiles {
  issues_open: number;
  issues_new_24h: number;
  top_3: SentryTopIssue[];
  sparkline: SentrySparklineBucket[];
}

export interface SentrySummaryResponse {
  configured: boolean;
  error: string | null;
  fetched_at: string | null;
  org_slug: string | null;
  tiles: SentrySummaryTiles | null;
}

export function useAdminSentrySummary() {
  return useQuery<SentrySummaryResponse>({
    queryKey: ["admin", "sentry", "summary"],
    queryFn: () =>
      apiClient.get("api/admin/sentry/summary").json<SentrySummaryResponse>(),
    staleTime: 60_000,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
